import * as allTypes from '../mutation-type';
import * as types from './societe-mutation-type';
import { getAllSocietes, GetSupportCommercialAsync } from '@/api/societe/index';
import { getPJsLogoByIds } from '@/services/piecesJointes/getPiecesJointeLogoByIds';
import { getAllProduits } from '@/api/produit';
import { SENS_VENTE } from '@/configuration/devisConf';
import getSocieteDefautUtilisateur from '@/services/societe/getSocieteDefautUtilisateur';

function initialState() {
  return {
    societeActive: {},
    societes: [],
    societeActiveId: null,
    supportCommerciaux: [],
    logo: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_SOCIETE_ACTIVE](state, societe) {
    state.societeActive = societe;
  },
  [types.SET_SOCIETES](state, data) {
    state.societes = data;
  },
  [types.SET_SOCIETE_ACTIVE_ID](state, id) {
    state.societeActiveId = id;
  },
  [types.SET_SUPPORT_COMMERCIAUX](state, supports) {
    state.supportCommerciaux = supports;
  },
  [types.SET_LOGO](state, value) {
    state.logo = value;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  loadSocietes: async({dispatch, getters, rootGetters}) => {
    try {
      const societes = (await getAllSocietes()).data;
      // chargement produits par défaut dans la societe
      const produitsDefautIds = societes
        .flatMap(s => [
          s.produitIdHonoraire,
          s.produitIdDefautTlpe,
          s.produitIdDefautFraisTechnique,
          s.produitIdHonoraireForfaitaire,
          s.produitIdHonoraireFraisTraitement,
        ])
        .filter(Boolean);
      if (produitsDefautIds.length > 0) {
        const produitsDefault = (await getAllProduits({
          query: { actif: true, sens: SENS_VENTE, ids: produitsDefautIds },
          maxResultCount: 20,
          inclusion: ['grilleTarifaire'],
        })).data.result.items;
        societes.forEach(s => {
          s.produitTlpe = produitsDefault.find(p => p.id === s.produitIdDefautTlpe) || null;
          s.produitHonoraire = produitsDefault.find(p => p.id === s.produitIdHonoraire) || null;
          s.produitFraisTechnique = produitsDefault.find(p => p.id === s.produitIdDefautFraisTechnique) || null;
          s.produitHonoraireForfaitaire = produitsDefault.find(p => p.id === s.produitIdHonoraireForfaitaire) || null;
          s.produitHonoraireFraisTraitement = produitsDefault.find(p => p.id === s.produitIdHonoraireFraisTraitement) || null;
        });
      }
      await dispatch('setLogoSocieteAsync', societes);
      if (!getters.societeActiveId && societes && societes.length > 0) {
        await dispatch('setSocieteId', getSocieteDefautUtilisateur(societes, rootGetters['user/user']));
      }
      return true;
    } catch (e) {
      return e;
    }
  },
  setLogoSocieteAsync: async ({ commit }, societes) => {
    const societeIds = societes.map(s => s.id);
    const res = await getPJsLogoByIds(societeIds);
    const logoUrl = res.length > 0 ? res[0].chemin : '';
    commit(types.SET_LOGO, logoUrl);
    societes.forEach(soc => {
      const logo = res.find(pj => {
        return pj.elementId === soc.id;
      });
      if (logo) {
        soc.logo = logo.chemin;
      }
    });
    commit(types.SET_SOCIETES, societes);
  },
  setSocieteId: async ({ commit, getters }, id) => {
    if (id !== null && (getters.societeActiveId !== id || getters.societeActive === null)) {
      const findSociete = getters.societes.find(s => s.id === id);
      commit(types.SET_SOCIETE_ACTIVE, findSociete);
    }
    commit(types.SET_SOCIETE_ACTIVE_ID, id);
    const supportCommerciaux = (await GetSupportCommercialAsync(id)).data.result.items;
    commit(types.SET_SUPPORT_COMMERCIAUX, supportCommerciaux);
  },
};

const getters = {
  societeActive: state => {
    return state.societeActive;
  },
  societeActiveId: state => {
    return state.societeActiveId;
  },
  societes: state => {
    return state.societes;
  },
  supportCommercial: state => (cat) => {
    return state.supportCommerciaux.find((s) => s.categorieVente === cat);
  },
  logo: state => {
    return state.logo;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
